import { SetPasswordIcon } from 'common/Icons';
import { useTranslation } from 'react-i18next';
import { FormForgetChange } from './components/FormForgetChange';

function MobileRequest() {
  const { t } = useTranslation();

  return (
    <div className="bg-L-gray-50 dark:bg-D-gray-50 h-[100vh] inset-0 relative grid grid-rows-min-one">
      <div>
        <div className=" absolute left-0 top-0">
          <SetPasswordIcon />
        </div>

        <div className="p-4 mt-20">
          <div className="mt-10">
            <h1 className="text-5xl text-L-gray-400 my-4">
              {t(`FormSide.ResetPasswordText`)}
            </h1>
            <FormForgetChange />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileRequest;
